var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckoutApprove',{attrs:{"uuid":_vm.uuid,"details":_vm.orderData}})
}
var staticRenderFns = []

export { render, staticRenderFns }